import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { HelperService } from 'src/services/helperService';

import { CancelAppointmentDialog } from '../cancel-appointment/cancel-appointment.dialog';
import { SchedulingComponent } from '../../scheduling.component';
import { RescheduleAppointmentDialog } from '../reschedule-appointment/reschedule-appointment.dialog';

@Component({
    selector: 'app-popover-rescheduling',
    templateUrl: './popover-rescheduling.component.html',
    styleUrls: ['./popover-rescheduling.component.sass'],
    standalone: false
})
export class PopoverReschedulingComponent implements OnInit {
  userProfile: User;
  isDisabled = false;
  roleId: number = this.helperService.user.role.roleId
  areFiltersLoading: boolean = false; //are filters loading variable 
  constructor(@Inject(MAT_DIALOG_DATA) public hoveredData: any, 
  public dialog: MatDialog,
  public helperService: HelperService,public schedulerService: APISchedulerService,private translate: TranslateService,public dialogRef: MatDialogRef<SchedulingComponent>) {    this.userProfile = this.helperService.user;}
  showLastName: boolean = true;
  ngOnInit(): void {
    let hour = this.hoveredData.hour.split('-')
    let hourformat = hour[0].replace('a. m.', 'A. M.').replace('p. m.', 'P. M.') + "-" + hour[1].replace('a. m.', 'A. M.').replace('p. m.', 'P. M.')
    this.hoveredData.hour = hourformat
    this.hoveredData.clientLastName === 'NaN' ? this.showLastName = false : this.showLastName = true
  }

  clientAssisted(value: number) {
    // set ASISTiÖ or NO ASISTIÓ depending of recieved value (2 || 3)
    // calls the back to update the field on the DB
    this.isDisabled=true
    this.areFiltersLoading = true
    let appointment = this.hoveredData;
    let scheduleGet;
    
    {
      let scheduleService = this.schedulerService
        .get(appointment.id)
        .subscribe({
          
          next: (schedule) => {            
            Object.keys(schedule).forEach(key => {
              if (schedule[key] === null) {
                schedule[key] = "";
              }
            });
            schedule.schedulerStatusId = value;
            scheduleGet = schedule;
            scheduleGet.sendToHabeasData = scheduleGet.sendToHabeasData ? scheduleGet.sendToHabeasData : false
            scheduleGet.sendToKeyloop = scheduleGet.sendToKeyloop ? scheduleGet.sendToKeyloop : false
            scheduleGet.sendToSap = scheduleGet.sendToSap ? scheduleGet.sendToSap : false
            scheduleGet.representativeId ? null : delete scheduleGet.representativeId 
            delete scheduleGet.dataProcessing;
          },
          
          complete: () => {   
            this.schedulerService.put(scheduleGet).subscribe({
              next: (response) => {
                const clientData = {
                  clientFirstName: appointment.clientFirstName.toUpperCase(),
                  clientLastName: appointment.clientLastName.toUpperCase(),
                  plate: appointment.plateNo.toUpperCase(),
                  typeOfService: appointment.typeOfService.toUpperCase()
                }
                this.isDisabled=false
                const checkInMsg = this.translate.instant('CheckInMsg',clientData)
                if (response.schedulerStatusId === 2) {
                  this.areFiltersLoading = false
                  this.dialogRef.close();
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="success"
                  this.helperService.messageAlert =checkInMsg
                  setTimeout(() => {
                    this.helperService.showAlert =false
                    }, 7000)
                } else {
                  const clientNotAssisted =  this.translate.instant('ClientNotAssisted',clientData)
                  this.areFiltersLoading = false
                  this.dialogRef.close();
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="warning"
                  this.helperService.messageAlert =clientNotAssisted
                  setTimeout(() => {
                    this.helperService.showAlert =false
                    }, 7000)
                }
              },
            });
            
            scheduleService.unsubscribe;
          }, error: (error) => {
          

              if(error.status === 401){
                this.helperService.logoutToken()
              }
              else {
              
            
            this.areFiltersLoading = false
            this.dialogRef.close();
            const translateTxtNotMatch = this.translate.instant("notMatchFound") 
            this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
           this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
            this.helperService.showAlert =false
            }, 7000)}
    
          }
        });
    }
  }


  rescheduleAppointment() {
    let appointment = this.hoveredData;
    
    if (this.roleId === 1) {
      appointment.attentionSchedule = this.hoveredData.attentionSchedule
      appointment.schedules = this.hoveredData.schedules
      appointment.blocks = this.hoveredData.blocks
    }

    if (this.roleId === 2) {
      appointment.attentionSchedule = this.hoveredData.attentionSchedule
      appointment.schedules = this.hoveredData.schedules
      appointment.blocks = this.hoveredData.blocks
    }

    //CONTACT CENTER 
    if (this.roleId===3) {
      appointment.attentionSchedule = this.hoveredData.attentionSchedule
      appointment.schedules = this.hoveredData.schedules
      appointment.blocks = this.hoveredData.blocks
     }

    

    this.dialog.open(RescheduleAppointmentDialog, {
      width: '903px',
      panelClass: 'icon-outside',
      data: appointment,
    });
    this.dialogRef.close();
  }
  
  cancelAppointment() {
    // Opens the dialog to cancel scheduled appointment and listens for recieved object
    let appointment = this.hoveredData

    this.dialog.open(CancelAppointmentDialog, {
      width: '600px',
      panelClass: 'icon-outside',
      data: appointment,
    });
    this.dialogRef.close();

  }
  onCancel(){this.dialogRef.close();}

  DisableEditAndCancel(): boolean {
    const now = new Date();
    const eventStart = new Date(this.hoveredData.EventStart);
    const diff = eventStart.getTime() - now.getTime();
    return diff > 5 * 60 * 1000;
  }

  DisableShowNoShow() {
  const now = new Date();
  const eventStart = new Date(this.hoveredData.EventStart);

  // Normalizar fechas (sin horas)
  const todayNoTime = new Date(now.setHours(0, 0, 0, 0));
  const eventNoTime = new Date(eventStart.setHours(0, 0, 0, 0));

  // Diferencia en días
  const diffMs = todayNoTime.getTime() - eventNoTime.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  // Condición:
  // - Es el mismo día
  // - Y no tiene más de 5 días de antigüedad
  return diffDays >= 0 && diffDays <= 5;
}


}
